import { downloadDocument } from 'src/services/individualService'

const documentDownload = async (document, documentURL) => {
  let documentName = null
  let documentId = null
  if (document.length) {
    documentId = document[0].data.id
    documentName = document[0].name
  }
  if (documentId || documentURL) {
    await downloadDocument(documentName, documentId, documentURL)
  }
}

export default documentDownload
